import { Action } from '@ngrx/store';


export enum EUOMActions {
    GetUOM = '[UOM] Get UOM',
    GetUOMDetails = '[UOM] Set UOM Details',
    AddUOM = '[UOM] Add UOM',
    // EditUOM = '[UOM] Edit UOM',
    SetUOMSuccess = 'Set UOM Success',
    SetUOMError = 'Set UOM Error',
    EditUOM = '[UOM] Edit UOM',
    GetEditUOMSuccess = '[UOM] Get Edit UOM Success',
    GetEditUOMError = '[] Get Edit UOM Error',
}

export class GetUOM implements Action {
    public readonly type = EUOMActions.GetUOM;
    constructor(public payload: any) {}
}

export class GetUOMDetails implements Action {
    public readonly type = EUOMActions.GetUOMDetails;
    constructor(public payload: any) {
    }
}

export class AddUOM implements Action {
    public readonly type = EUOMActions.AddUOM;
    constructor(public payload: any) {
    }
}

export class SetUOMSuccess implements Action {
    public readonly type = EUOMActions.SetUOMSuccess;
    constructor(public payload: any, public from: any) {
    }
}

export class SetUOMError implements Action {
    public readonly type = EUOMActions.SetUOMError;
    constructor(public payload: any, public from: any) {
    }
}

export class EditUOM implements Action {
    public readonly type = EUOMActions.EditUOM;
    constructor(public payload: any) {
    }
}
export class GetEditUOMSuccess implements Action {
    public readonly type = EUOMActions.GetEditUOMSuccess;
    constructor(public payload: any) {
    }
}
export class GetEditUOMError implements Action {
    public readonly type = EUOMActions.GetEditUOMError;
    constructor(public payload: any) {
    }
}
export type UOMAction =  GetUOM | GetUOMDetails | SetUOMSuccess | SetUOMError | AddUOM | EditUOM | 
                         GetEditUOMSuccess | GetEditUOMError;